/* eslint-disable */
import Swiper, { Autoplay, Navigation, Pagination, Thumbs } from 'swiper';
export default {
  init() {
    function readCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }

    //for the popup on <a> tags
    $('.do-popup').click(function () {
      if($(this).attr('data-redirecturl')) {
        alert('Je zal nu worden doorgestuurd naar: '+$(this).attr('data-redirecturl'));
      }
      else {
        alert('Je zal nu worden doorgestuurd');
      }
    });

    var hamburger = $('#hamburger-icon');
    hamburger.click(function () {
      hamburger.toggleClass('active');
      $('.header__nav-mobile').fadeToggle();
      $('.header__nav').toggleClass('sticky-menu-fix');
      //return false;
    });
    // JavaScript to be fired on all pages
    $('.toggle__regio').on('click', function () {
      $('.b__fullpage-map').toggleClass('stickyfix');
      $('header.header__nav').toggleClass('stickyfix');
      $('.b__fullpage-map').fadeToggle();
    });
    $('.map-continents-go-back').on('click', function () {
      $('.b__fullpage-map').removeClass('stickyfix');
      $('header.header__nav').removeClass('stickyfix');
      $('.b__fullpage-map').fadeOut();
    });

    $('.catradio').on('change', () => {
      var filter = $('#filter');
      $.ajax({
        url: filter.attr('action'),
        data: filter.serialize(), // form data
        type: filter.attr('method'), // POST
        beforeSend: function () {
          $('#response').addClass('loading'); // changing the button label
        },
        success: function (data) {
          $('#response').removeClass('loading');
          $('#response').html(data); // insert data
        },
      });
      $('#pagi').fadeOut();
      return false;
    });
    $('.contact-popup-btn').on('click', function () {
      $('.c__form-popup').fadeIn();
      $('body').css({ 'overflow': 'hidden' });
    });
    $('.close-btn').on('click', function () {
      $('.c__form-popup').fadeOut();
      $('body').css({ 'overflow': 'unset' });
    });
    $('.close-btn-grav').on('click', function () {
      $('.c__form-popup').fadeOut();
      $('body').css({ 'overflow': 'unset' });
    });

    Swiper.use([Autoplay, Navigation, Pagination, Thumbs]);
    //leden slider
    const storiesswiper = document.getElementById('swiper__stories-container');

    if (storiesswiper) {
      const storiesswiper = new Swiper('#swiper__stories-container.swiper-container', {
        // Optional parameters
        slidesPerView: 1,
        spaceBetween: 16,
        loop: false,
        grabCursor: true,
        breakpoints: {
          // when window width is >= 320px
          380: {
            slidesPerView: 1.2,
            spaceBetween: 16,
          },
          // when window width is >= 480px
          640: {
            slidesPerView: 2.2,
            spaceBetween: 16,
          },
          // when window width is >= 640px
          960: {
            slidesPerView: 3.2,
            spaceBetween: 16,
          },
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },

      })
      storiesswiper.init();

      //   const curSwiperEl = document.getElementById('swiperCur');
      //   const totalSwiperEl = document.getElementById('swiperTotal');
      //   const totalSwiper = storiesswiper.slides.length;
      //   totalSwiperEl.textContent = totalSwiper;

      //   let curSwipe = storiesswiper.activeIndex + 1;
      //   curSwiperEl.textContent = curSwipe;

      //   storiesswiper.on('slideChange', function () {
      //     let curSwipeReal = storiesswiper.activeIndex + 1;
      //     curSwiperEl.textContent = curSwipeReal;
      //   });
    }

    const agendaswiper = document.getElementById('swiper__agenda-container');

    if (agendaswiper) {

      const agendaS = new Swiper('#swiper__agenda-container', {
        // Optional parameters
        slidesPerView: 1,
        spaceBetween: 16,
        loop: false,
        grabCursor: true,

        breakpoints: {
          // when window width is >= 320px
          380: {
            slidesPerView: 1.2,
            spaceBetween: 16,
          },
          // when window width is >= 480px
          640: {
            slidesPerView: 3.5,
            spaceBetween: 16,
          },
          // when window width is >= 640px
          960: {
            slidesPerView: 4.5,
            spaceBetween: 16,
          },
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
        },

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },

      })

      agendaS.init()
    }



    $('.info-buttons .specs').on('click', function (e) {
      e.preventDefault();
      if ($('.specification-dropdown').hasClass('visible')) {
        $('.specification-dropdown').animate({ height: "hide" }, 500);
        $('.specification-dropdown').removeClass('visible');
      }
      else {
        $('.specification-dropdown').animate({ height: "show" }, 500);
        $('.specification-dropdown').addClass('visible');
      }
    });
    $('.info-buttons .downloads').on('click', function (e) {
      if ($(".file-title")[0])
        e.preventDefault();
      if ($('.download-dropdown').hasClass('visible')) {
        $('.download-dropdown').animate({ height: "hide" }, 500);
        $('.download-dropdown').removeClass('visible');
      }
      else {
        $('.download-dropdown').animate({ height: "show" }, 500);
        $('.download-dropdown').addClass('visible');
      }
    });

    $('.header__video-big .playbutton').on('click', function (e) {
      $('.header__video-big video').trigger('play');
      $('.header__video-big .playbutton').hide();
      $('.header__video-big .pauzebutton').show();
    });
    $('.header__video-big .pauzebutton').on('click', function (e) {
      $('.header__video-big video').trigger('pause');
      $('.header__video-big .pauzebutton').hide();
      $('.header__video-big .playbutton').show();
    });
    $('.header__video-big').hover(
      function () {
        if (!$('.header__video-big .playbutton').is(":visible")) {
          $('.header__video-big .pauzebutton').show();
        }
      },
      function () {
        $('.header__video-big .pauzebutton').hide();
      }
    );
    // Product swiper

    const checkSwiper = document.querySelector('.gallery-top');

    if (checkSwiper) {

      Swiper.use([Navigation, Thumbs]);

      var galleryThumbs = new Swiper('.gallery-thumbs', {
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
      });

      galleryThumbs.init();

      new Swiper('.gallery-top', {
        autoHeight: true,
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        thumbs: {
          swiper: galleryThumbs,
        },
      });

    }

    // about swiper

    const checkSwiperAbout = document.querySelector('.gallery-about');

    if (checkSwiperAbout) {

      Swiper.use([Navigation]);

      var swiperAbout = new Swiper('.gallery-about', {
        spaceBetween: 0,
        slidesPerView: 1,
      });

      swiperAbout.init();

    }
    // $(document).ready(function () {
    //   if (!readCookie('s_region'))
    //     $('.toggle__regio').click();
    // });
    $(window).on('load', function() {
    if (!readCookie('s_region')) {
        $('.toggle__regio').click();
    }
});
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $('.close-btn-grav').on('click', function () {
      $('.c__form-popup').fadeOut();
    });
    // $(".b__special_scroll_fix").css({'overflow-y': 'auto', 'max-height' : '100%'});

    $('.close-btn-grav').on('click', function () {
      $('.c__form-popup').fadeOut();
    });
  },
};




// WEBPACK FOOTER //
// ./scripts/routes/common.js